// extracted by mini-css-extract-plugin
export default {"root":"CookieWarning_root__nB8oD"};